'use client';

import { SyntheticEvent, useEffect } from 'react';
import { useSetAtom } from 'jotai';
import { LandingPage } from '@sapientpro/sapientpro-data-models';
import Button, { ButtonVariants } from '../../components/Button';
import styles from './POSTerminal.module.scss';
import contactModalTriggerButton, { contactExpert } from '../../store/contactForm';

const ContactButton = ({ expert, ctaButton }: { expert: LandingPage['expert']; ctaButton: LandingPage['ctaButton'] }) => {
  const setContactsModalTrigger = useSetAtom(contactModalTriggerButton);
  const setContactExpert = useSetAtom(contactExpert);

  useEffect(() => {
    setContactExpert(expert);

    return () => setContactExpert(null);
  }, [expert, setContactExpert]);

  const handleGetExpertAdviceClick = (event: SyntheticEvent) => {
    setContactsModalTrigger(`${(event.target as HTMLElement).innerText} | pos terminal landing page section`);
  };

  return (
    <Button
      variant={ButtonVariants.OUTLINED}
      className={styles.headerSection__contentButton}
      icon={(
        <svg>
          <use
            xlinkHref='/media/icon-nest.svg#iconNest'
            href='/media/icon-nest.svg#iconNest'
          />
        </svg>
              )}
      iconPosition='right'
      iconSize={{ width: 24, height: 24 }}
      size='normal'
      onClick={handleGetExpertAdviceClick}
    >
      {ctaButton}
    </Button>
  );
};

export default ContactButton;
